module.exports = __webpack_public_path__ + "static/media/onboarding5.b7ad3e3a.svg";